import React, { useEffect, useState } from "react";
import { useMeetingHistory } from "store/actions";
import Columns from "./Columns";
import { useDispatch } from "react-redux";
import Table from "components/Table";
import { FadeLoader } from "react-spinners"; 
import { useNavigate } from "react-router-dom";
import PatientColumns from "./PatientColumns";
// import PatientColumns from "./PatientColumns"
const MeetingHistory = ({ user_id, userType, filtereddoctorsData, isFiltered, selected, count, setNextPage, setNewFilter, newFilter}) => {
  const [meetingData, setMeetingData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [columns, setcolumns] = useState();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [filter, setFilter] = useState({
    pageNo: currentPage,
    limit: pageSize,
  });
  useEffect(() => {
    // MeetingHistory(filter);
    setcolumns(
      Columns({ handleViewUser, currentPage: filter?.pageNo, pageSize })
    );
  }, [user_id, filter]);
  const MeetingHistory = () => {
    const payload = {
      ...filter,
      page: filter?.pageNo,
      record_count: filter?.limit,
      user_id: user_id,
      userType: userType,
    };
    try {
      setLoading(true);
      const callback = (err, res) => {
        if (err) {
          console.log(err);
          setLoading(false);
        } else {
          setMeetingData(res);
          setLoading(false);
        }
      };
      dispatch(useMeetingHistory({ data: payload, callback }));
    } catch (error) {
      console.log(error);
    }
  };
  const handleViewUser = (row) => {
    console.log(row, "row data");
    navigate(`${row?.meeting_information[0]?.meeting_id}`, { state: { row } });
  };
   const handleViewUserPatient = (row) => {
    console.log(row, "row data");
    navigate(`${row?.meeting_id}?meetingType=${selected}`, { state: { row } });
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setNextPage(pageNumber)
  };

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} /> 
        </div>
      )}
      {/* {!loading && !isFiltered &&
        (meetingData?.meeting_data?.length > 0 ? (
          <div className="tab-pane fade show active">
            <Table
              data={meetingData?.meeting_data}
              columns={columns}
              setFilter={setFilter}
              totalCount={meetingData?.total_record_count}
              handleTableChange={handlePageChange}
              filter={filter}
            />
          </div>
        ) : (
          <p style={{ textAlign: "center" }}>No data Found</p>
        ))} */}
      {
        ((filtereddoctorsData?.length > 0 && isFiltered) ? (
          <div className="tab-pane fade show active">
            <Table
              data={filtereddoctorsData}
              columns={PatientColumns({ filtereddoctorsData,handleViewUserPatient })}
              setFilter={setNewFilter}
              totalCount={count}
              handleTableChange={handlePageChange}
              filter={newFilter}
            />
          </div>
        ) : (
          <p style={{ textAlign: "center" }}>No data Found</p>
        ))}
    </>
  );
};

export default MeetingHistory;
